import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
import { DeviceDetectorService } from 'ngx-device-detector';
@Pipe({
  name: 'columnHtmlTemplate'
})
export class ColumnHtmlTemplatePipe implements PipeTransform {
  private isMobileOrTablet = false;
  constructor(deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }
  transform(value: any, rowData: GridItem, htmlTemplate: (value: any, rowData?: any, isMobileOrTablet?: boolean) => string): string {
    if (typeof (htmlTemplate) !== 'function') {
      return value;
    }
    return htmlTemplate(value, rowData, this.isMobileOrTablet);
  }
}
